/* eslint-disable react/jsx-pascal-case */
import React from "react";

import Desktop from "./Desktop/D_main";
import Mobile from "./Mobile/Mobile";

function App() {
  if (window.innerWidth > 900) {
    return <Desktop />;
  } else {
    return <Mobile />;
  }
}

export default App;
